import React, { useEffect, useRef, useState } from 'react';

import cx from 'classnames';

import Tooltip, { TooltipText } from 'components/shared/Tooltip';
import generateRandomString from 'utils/generateRandomString';

import styles from './index.module.css';

function TextCell({ text }) {
  const [id] = useState(generateRandomString(6));
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef(null);
  const textContainerRef = useRef(null);

  useEffect(() => {
    const textContainerEl = textContainerRef.current;
    const textEl = textRef.current;
    if (!textEl || !textContainerEl) return;

    const listener = () => {
      const textRect = textEl.getBoundingClientRect();
      const textContainerRect = textContainerEl.getBoundingClientRect();
      setIsTruncated(textRect.width > textContainerRect.width);
    };

    listener();
    window.addEventListener('resize', listener);

    return () => window.removeEventListener('resize', listener);
  }, [text]);

  if (!text) {
    return '—';
  }

  return (
    <div className={styles.tooltipContainer} data-tip data-for={`textCell__${id}`}>
      <div ref={textContainerRef} className={cx(styles.text, isTruncated && styles.truncatedText)}>
        <span ref={textRef}>{text}</span>
      </div>

      <Tooltip place="bottom" id={`textCell__${id}`} withMouseOver noPadding disable={!isTruncated}>
        <TooltipText className={styles.tooltipText}>{text}</TooltipText>
      </Tooltip>
    </div>
  );
}

export default TextCell;
